import { createFormState, hasLength } from 'redux-freeform';

const returnFormConfig = {
  notes: {
    defaultValue: '',
    validators: [hasLength(0, 250)], // optional field
  },
};

export const {
  reducer: returnFormReducer,
  mapStateToProps: returnFormMapStateToProps,
  mapDispatchToProps: returnFormMapDispatchToProps,
} = createFormState(returnFormConfig);
